import logo from './logo.svg';
import './App.css';
import Home from './Pages/Home';
import Allroutes from './Routes/Allroutes';
import Sign_in_page from './Pages/Sign_in_page';

function App() {
  return (
  <>
  <Allroutes/>
  {/* <Home/>
  <Sign_in_page/> */}
  </>
  );
}

export default App;
